module.exports = __webpack_public_path__ + "img/badge_gray_pop-admission.9d5046be.svg";